import "./ContactSection.scss"
import PopupForm from './../Popup/Popup';
import React, {useState} from "react";

const ContactSection = ({scrollToHeader}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };


  return (
    <>
      <section id="contact" className="contact">
        <h1 className="title-contact">Contact Us</h1>
        <div className="content">
          <div className="container">
            <div className="contact-info">
              <div className="message">
                <p>— Write us about your project, and we’ll solve your case efficiently. Want things done
                  even faster? Start with filling in our brief-like form
                </p>
                <span className="ceo-aftername">Aleksandr, CEO</span>
              </div>
            </div>
          </div>
          <div className="button-info">
            <div className="button-center">
              <button onClick={handleOpenPopup} className='button-contact open-popup-btn'>contact us</button>
            </div>
            {isPopupOpen && <PopupForm onClose={handleClosePopup}/>}
          </div>
        </div>

        <footer className="footer">
          <div className="link-privacy">
            <a href="/privacy-policy">Privacy Policy</a>
            <span>© 2025 | Kanzu</span>
          </div>

          <div className="button-top">
            <button onClick={scrollToHeader} aria-label="Back to top">
              <svg width="24" height="36" viewBox="0 0 29 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2278 1.65006L14.2278 45.5601M14.2278 1.65006L27.6878 15.1101M14.2278 1.65006L0.76776 15.1101"
                    stroke="#5B5567" strokeWidth="2"
                />
              </svg>
            </button>
            <span>Back to top</span>
          </div>
        </footer>

      </section>
    </>
  );
}

export default ContactSection;